export function getHeaderKey<T>(header: any) {
  return header.value
}